// Configuration EmailJS
// Utilise les variables d'environnement ou des valeurs par défaut

export const EMAIL_CONFIG = {
  // Votre User ID EmailJS (trouvé dans votre compte EmailJS)
  USER_ID: process.env.REACT_APP_EMAILJS_USER_ID || '09q9cH7jCyVfwe-q6',
  
  // ID du service EmailJS (Gmail, Outlook, etc.)
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_5tfccpu',
  
  // ID du template EmailJS
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_3l3jt56',
  
  // Email de destination (votre email)
  TO_EMAIL: process.env.REACT_APP_TO_EMAIL || 'faustinagohoundje@gmail.com'
};

// Instructions pour configurer EmailJS :
// 1. Allez sur https://www.emailjs.com/
// 2. Créez un compte gratuit
// 3. Ajoutez un service email (Gmail, Outlook, etc.)
// 4. Créez un template d'email
// 5. Remplacez les valeurs ci-dessus par vos vraies clés
